import Button, { ButtonProps } from "@mui/material/Button";
import { parseISO } from "date-fns";
import { useCallback, useMemo, useState } from "react";
import { useQuery, useMutation } from "react-query";
import { Dialog } from "../Dialog";
import { DialogSuccessCampaign } from "../DialogSuccessCampaign";
import { Timeline } from "../Timeline";
import { listProfilesCampaign } from "../../services/results";
import { NewCampaign } from "../../pages/CreateCampaign/New";
import { NewAudience } from "../CreateAudience";
import { Insights } from "../../types/insights";
import { listInsights } from "../../services/insights";
import { Campaign } from "../../types/campaign";
import { CustomerTable } from "../CustomerTable";
import { useToast } from "../../hooks/useToast";
import { updateNotShow } from "../../services/insights";

type DialogProfileProps = {
  data: Campaign;
  open: boolean;
  onClose: () => void;
  isCampaign?: boolean;
  onSuccesss?: () => void;
};

export function DialogProfile(props: DialogProfileProps) {
  const { data, open, onClose, isCampaign = false, onSuccesss = null } = props;
  const [dialogNewCampaign, setDialogNewCampaign] = useState(false);
  const [dialogNewAudience, setDialogNewAudience] = useState(false);
  const [dialogSuccesCampaign, setDialogSuccessCampaign] = useState(false);
  const [insight, setInsight] = useState<Insights | null>(null);

  const insights = useQuery("insights", listInsights, {
    cacheTime: 30 * 1000,
  });

  const execUpdateAudience = useMutation(
    async (param1: any) => {
      const response = await updateNotShow(param1.idList, param1.not_show);
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Sucesso ao cadastrar audiência!", { severity: "success" });
      },
      onError: () => {
        toast.show("Erro ao cadastrar audiência!", {
          severity: "error",
        });
      },
    }
  );

  function updateNot(typeCampaing) {
    let audiences: any = [];
    for (let i = 0; i < insights.data?.length; i++) {
      if (
        insights.data[i].prospeccao_origem === data.id_lista_prospeccao &&
        insights.data[i].prospeccao_tipo === typeCampaing
      ) {
        audiences.push(insights.data[i]);
      }
    }
    let audience = audiences[0];
    return audience;
  }

  const toast = useToast();

  const profiles = useQuery(
    ["profiles", data?.ID_CAMPANHA],
    async () => {
      const response = await listProfilesCampaign(
        parseISO(String(data?.data_inicio_campanha)?.replace("Z", "")),
        parseISO(String(data?.data_fim_campanha)?.replace("Z", "")),
        data?.ID_CAMPANHA
      );
      return response;
    },
    { enabled: Boolean(data) && Boolean(data?.ID_CAMPANHA) }
  );

  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Fechar",
        onClick: onClose,
      },
    ];
  }, [onClose]);

  const bought = useMemo(() => {
    let yes = [];
    let not = [];
    profiles.data?.forEach((value) => {
      if (Number(value.ticket_medio) > 0) {
        yes.push(value);
      } else {
        not.push(value);
      }
    });
    return { yes, not };
  }, [profiles.data]);

  const buttonCriarAudiencia = () => {
    if (data.processado === 2) {
      return false;
    } else {
      return true;
    }
  };

  const handleDialogNewAudience = () => {
    setDialogNewAudience((prev) => !prev);
  };

  const handleDialogNewCampaign = () => {
    if (insights.isFetching) return;
    let findInsight = insights.data?.find(
      (value) => value.idListProspectei === data?.id_lista_prospeccao
    );
    let childType1;
    let childType2;
    if (!dialogNewCampaign) {
      childType1 = insights.data?.find(
        (value) =>
          value.prospeccao_origem === data?.id_lista_prospeccao &&
          value.prospeccao_tipo === 1
      );
      if (!childType1) {
        toast.show("Não foi encontrado audiências vinculadas!", {
          severity: "error",
        });
        return;
      }
      childType2 = insights.data?.find(
        (value) =>
          value.prospeccao_origem === data?.id_lista_prospeccao &&
          value.prospeccao_tipo === 2
      );
      if (!childType2) {
        toast.show("Não foi encontrado audiências vinculadas!", {
          severity: "error",
        });
        return;
      }
    }
    setDialogNewCampaign((prev) => !prev);
    if (findInsight) {
      return setInsight({
        ...findInsight,
        fullListProspecteiType1: childType1,
        fullListProspecteiType2: childType2,
      });
    }
    setInsight(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const handleDialogSuccessCampaign = useCallback(() => {
    setDialogSuccessCampaign((prev) => !prev);
  }, []);

  const tabs = [
    {
      label: "Todos",
      index: 0,
      children: (
        <CustomerTable isLoading={profiles.isLoading} data={profiles.data} />
      ),
    },
    {
      label: "Compraram",
      index: 1,
      children: (
        <CustomerTable isLoading={profiles.isLoading} data={bought.yes} />
      ),
    },
    {
      label: "Não Compraram",
      index: 2,
      children: (
        <CustomerTable isLoading={profiles.isLoading} data={bought.not} />
      ),
    },
  ];

  return (
    <>
      <Dialog
        onClose={onClose}
        fullWidth
        maxWidth="lg"
        title="Clientes"
        open={open}
        actions={actions}
      >
        {!isCampaign && (
          <CustomerTable isLoading={profiles.isLoading} data={profiles.data} />
        )}

        {isCampaign && (
          <Timeline
            padding="0"
            tabs={tabs}
            marginTop={0.5}
            button={
              <>
                <Button
                  sx={{ p: "8px 16px", color: "#696969", marginRight: "15px" }}
                  disabled={buttonCriarAudiencia()}
                  onClick={() => {
                    handleDialogNewAudience();
                    // onClose();
                  }}
                >
                  Criar audiência
                </Button>

                <Button
                  data-testid="btn-new-remarketing-campaign"
                  variant="contained"
                  sx={{ p: "8px 16px" }}
                  onClick={() => {
                    handleDialogNewCampaign();
                    // onClose();
                  }}
                  disabled={insights.isFetching}
                >
                  Nova campanha
                </Button>
              </>
            }
          />
        )}
      </Dialog>

      {dialogNewCampaign && (
        <NewCampaign
          isChild={true}
          parentCampaignName={data?.nome_campanha}
          parentCampaignId={data?.ID_CAMPANHA}
          parentCampaignEndDate={data?.data_fim_campanha}
          open={dialogNewCampaign}
          onClose={handleDialogNewCampaign}
          onSuccess={handleDialogSuccessCampaign}
          insight={insight}
        />
      )}

      {dialogNewAudience && (
        <NewAudience
          data={data}
          open={dialogNewAudience}
          onClose={handleDialogNewAudience}
          updateNot={async (typeCampaing) => {
            let audience = updateNot(typeCampaing);
            handleDialogNewAudience();
            const obj = { idList: audience.idListProspectei, not_show: 0 };
            try {
              await execUpdateAudience.mutateAsync(obj);
            } catch (err) {
              console.log({ err });
            }
          }}
        />
      )}

      <DialogSuccessCampaign
        open={dialogSuccesCampaign}
        onClose={() => {
          handleDialogSuccessCampaign();
          if (onSuccesss) onSuccesss();
        }}
      />
    </>
  );
}
